import { Mail, Phone, UserRound } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";

export default function Consultants({ consultants }) {
  return (
    <section id="ansprechpartner" data-testid="consultants-section" className="py-24 sm:py-32 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          number="04"
          label="Ansprechpartner"
          title="Ihre Ansprechpartner für KIA Firmenkunden"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {consultants.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.1}>
              <div data-testid={`consultant-card-${i}`} className="bg-white border border-neutral-200 overflow-hidden">
                <div className="aspect-[4/3] bg-neutral-200 relative overflow-hidden">
                  {c.photo_url ? (
                    <img src={c.photo_url} alt={c.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center text-neutral-400">
                      <UserRound size={48} strokeWidth={1} />
                      <span className="mt-3 text-[10px] uppercase tracking-[0.25em] font-semibold">Foto folgt</span>
                    </div>
                  )}
                  {c.placeholder && (
                    <span className="absolute top-3 right-3 bg-neutral-950/80 text-white text-[9px] uppercase tracking-[0.2em] px-2.5 py-1">
                      Platzhalter
                    </span>
                  )}
                </div>
                <div className="p-7">
                  <h3 className="text-xl font-medium tracking-tight text-neutral-950" data-testid={`consultant-name-${i}`}>{c.name}</h3>
                  {c.role && <div className="mt-1 text-xs uppercase tracking-[0.2em] font-semibold text-neutral-500">{c.role}</div>}
                  <div className="mt-5 space-y-2 text-sm text-neutral-700">
                    <a href={`tel:${c.phone.replace(/\s/g, "")}`} className="flex items-center gap-2.5 hover:text-neutral-950" data-testid={`consultant-phone-${i}`}>
                      <Phone size={14} /> {c.phone}
                    </a>
                    <a href={`mailto:${c.email}`} className="flex items-center gap-2.5 hover:text-neutral-950" data-testid={`consultant-email-${i}`}>
                      <Mail size={14} /> {c.email}
                    </a>
                  </div>
                  <a
                    data-testid={`consultant-contact-${i}`}
                    href={`mailto:${c.email}?subject=KIA%20Firmenkunden%20Anfrage`}
                    className="mt-6 block text-center bg-neutral-950 text-white text-xs font-semibold px-5 py-3 transition-colors hover:bg-neutral-800"
                  >
                    Kontakt aufnehmen
                  </a>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-16 text-xl sm:text-2xl font-light text-neutral-700 max-w-2xl leading-relaxed">
            „Wir beraten Sie persönlich – vom einzelnen Geschäftsfahrzeug bis zur kompletten Firmenflotte."
          </p>
        </Reveal>
      </div>
    </section>
  );
}
